import { adsMenuItems } from './apps/ads/menu'
import { supervisoryMenuItems } from './apps/supervisory/menu'

const appVariants = {
  ads: {
    name: 'ads',
    defaultAuthenticatedRoute: '/AdCampaignList',
    menuItems: adsMenuItems
  },
  supervisory: {
    name: 'supervisory',
    defaultAuthenticatedRoute: '/DeviceList',
    menuItems: supervisoryMenuItems
  }
}

const requestedVariant = process.env.VUE_APP_SYSTEM_VARIANT

export const activeAppVariant = appVariants[requestedVariant] || appVariants.ads
export const supportedAppVariants = Object.keys(appVariants)
